import React, { SVGProps } from "react";

export default function SupIconSlider(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 10C10 11.1046 9.10457 12 8 12C6.89543 12 6 11.1046 6 10C6 8.89543 6.89543 8 8 8C9.10457 8 10 8.89543 10 10Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9691 10.5C11.723 12.4732 10.0398 14 8 14C5.96019 14 4.277 12.4732 4.03095 10.5H2V9.5H4.03095C4.277 7.52684 5.96019 6 8 6C10.0398 6 11.723 7.52684 11.9691 9.5H18V10.5H11.9691ZM10.9595 10.494C10.9861 10.3333 11 10.1683 11 10C11 9.82965 10.9858 9.6626 10.9585 9.5C10.7205 8.08114 9.4865 7 8 7C6.5135 7 5.27952 8.08114 5.04148 9.5C5.04115 9.50199 5.04081 9.50397 5.04048 9.50596C5.01385 9.66669 5 9.83173 5 10C5 10.1704 5.0142 10.3374 5.04148 10.5C5.27952 11.9189 6.5135 13 8 13C9.4865 13 10.7205 11.9189 10.9585 10.5C10.9589 10.498 10.9592 10.496 10.9595 10.494Z"
        fill="currentColor"
      />
    </svg>
  );
}
